import { FullServiceContactsProps } from 'src/api/ServiceContacts/types'

export type InfoContactWindowProps = {
  contact: FullServiceContactsProps
  isOpen: boolean
  toggle: () => void
  toggleEditMode: (contactId: string) => void
}

export enum FieldId {
  ServiceType = 'serviceType',
  AdditionalNotes = 'additionalNotes',
}
